module.exports = __webpack_public_path__ + "img/matImage.37cc8be1.svg";